// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_fNN1y","more":"more_He5VV"};